export default __webpack_public_path__ + "static/media/transactions.0caed640.jpg";